import React from "react";
import { LocationCard } from "@travellocal/ui";
import { GoogleAnalyticsHelper } from "@travellocal/ui";
import { SwipeCarousel } from "../../swipeCarousel/swipeCarousel";

import "./featuredCountriesCards.scss";

// TODO - these are hardcoded for now, will come from a homepage settings API in future
export const featuredLocationIds = [
  20, // Costa Rica (hero),
  63, // Vietnam
  1062, // Jordan
  581, // India
  1299, // Kenya
];

interface Props {
  locations: ILocationSummary[];
}

export const FeaturedCountriesCards = ({ locations }: Props) => {
  // TODO The api returns in alpha order - "resort" to desired order
  const featuredLocations = [
    locations[0],
    locations[4],
    locations[2],
    locations[1],
    locations[3],
  ].filter(x => x != null);

  return (
    <div className="featured-locations-cards">
      <div className="featured-locations-cards-grid">
        <div className="columns is-multiline is-paddingless">
          {featuredLocations.map((location, index) => (
            <div
              key={location.id}
              className={index === 0 ? "column is-full is-8-desktop" : "column is-6 is-4-desktop"}
            >
              <LocationCard
                location={location}
                highQuality
                onClick={() => GoogleAnalyticsHelper.logEvent("Select Country", "Click", "Homepage Featured Country Card")}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="featured-locations-cards-swipe-carousel">
        <SwipeCarousel>
          {featuredLocations.map(location => (
            <LocationCard
              key={location.id}
              location={location}
              onClick={() => GoogleAnalyticsHelper.logEvent("Select Country", "Click", "Homepage Featured Country Card")}
            />
          ))}
        </SwipeCarousel>
      </div>
    </div>
  );
};
